<div class="addon-page">
  <div class="empty-state" *ngIf="links && links.links?.length === 0">
    <mat-icon class="empty-state__icon">link</mat-icon>
    <p>{{ "addons.links.empty" | translate }}</p>
  </div>

  <div class="content" *ngIf="links && links.links?.length > 0">
    <div *ngFor="let link of links.links">
      <app-link [link]="link"></app-link>
    </div>
  </div>

  <div class="dbc1-loading dbc1-loading--overlay" *ngIf="!links">
    <app-loading></app-loading>
  </div>
</div>
